<template>
    <div class="col-md-12">
        <div class="pt-3">
            <div class="row my-3">
                <div class="col-md-8">
                    <div class="h2">External driver fees</div>
                    <div class="flash-message">
                        <FlashMessage :position="'top'"></FlashMessage>
                    </div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-12">
                    <div style="width: fit-content;">
                        <date-picker
                            :clearable="false"
                            :multiple="false"
                            :editable="false"
                            input-class="content"
                            valueType="YYYY-MM-DD"
                            v-model="filters.date"
                            :inline="true"
                            :lang="datePickerOptions.lang"
                            @change="onSelectDate"
                            :disabled-date="disabledDates"
                        ></date-picker>
                    </div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-12">
                    <div class="position-relative pagination-control table-hover">
                        <data-table
                            :columns="columns"
                            :url="tableUrl"
                            :per-page="perPage"
                            :order-by="orderBy"
                            :order-dir="orderDir"
                            :meta="columns.meta"
                            :classes="classes"
                            :translate="translate"
                            :filters="filters"
                            :debounce-delay=1000
                            ref="table"
                        >
                            <div slot="filters" slot-scope="{ tableFilters, perPage }"></div>
                            <thead class="clickable-header bg-page" style="color: #ffffff;" slot="header" slot-scope="{ tableFilters }">
                            <tr>
                                <th @click="sort(column.id)" v-if="column.label!==''"
                                    v-for="column in columns">
                                    <span> {{ column.label }}  </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id"
                                v-for="item in data">
                                <td :key="column.name"
                                    v-for="column in columns"
                                    class="laravel-vue-datatable-td border-0 text-left py-2 font-weight-normal"
                                >
                                    <data-table-cell
                                        :value="item"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === 'Date'">
                                        {{ formatDate(item.date) }}
                                    </slot>
                                    <slot v-if="column.label === 'Driver'">
                                        {{ item.driver.name }}
                                    </slot>
                                    <slot v-if="column.label === 'Cost'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.cost">
                                        </div>
                                    </slot>
                                    <slot v-if="column.label === 'Fees'">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <span class="material-icons-outlined text-primary cursor-pointer"
                                                      title="Show fees"
                                                      @click="showFees(item)"
                                                >add_circle</span>
                                            </div>
                                            <div class="ml-3">{{ item.fees.total }} kr.</div>
                                        </div>
                                    </slot>
                                    <slot v-if="column.label === 'Net cost'">
                                        {{ item.cost - item.fees.total }} kr.
                                    </slot>
                                    <slot v-if="column.label === 'Validated'">
                                        <div>
                                            <label class="newInput">
                                                <input type="checkbox" v-model="item.validated">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </slot>
                                </td>
                            </tr>
                            </tbody>

                            <div slot="pagination" slot-scope="{ links, meta }"
                                 class="d-flex justify-content-between align-items-center"
                            >
                                <div>
                                    <label class="pr-2">Per page:</label>
                                    <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <select class="form-control bg-white border-0 py-0 shadow-none " v-model="filters.length"
                                                style="width: 150px;">
                                            <option
                                                :key="index"
                                                :value="records"
                                                v-for="(records, index) in perPage">
                                                {{ records }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <pagination
                                    ref="pagination"
                                    :total-pages="meta.last_page"
                                    :current-page-prop="meta.current_page"
                                    v-if="meta && meta.last_page > 1"
                                ></pagination>
                            </div>
                        </data-table>
                        <div class="d-flex justify-content-end w-100">
                            <button type="button" class="btn btn-success" @click="saveAll">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            ref="modalFees"
            class="modal fade"
            :class="{show, 'd-block': activeModalFees}"
            tabindex="-1"
            role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="activeDriver">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ formatDate(activeDriver.date) }} - {{ activeDriver.driver.name }}. TOTAL fee: {{ activeDriver.fees.total }}
                        </h5>

                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="modalToggle('activeModalFees')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-bordered table-striped" aria-label="External driver fees table">
                            <thead>
                            <tr>
                                <th style="width: 50%;" class="text-center">Årsag</th>
                                <th style="width: 15%;" class="text-center">Beløb</th>
                                <th class="text-center">Stk</th>
                                <th class="text-center" style="width: 15%">Qty</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in activeDriver.fees.fees">
                                <td style="width: 50%;">{{ item.reason }}</td>
                                <td style="width: 15%;">{{ item.price }}</td>
                                <td>{{ item.stk }}</td>
                                <td>
                                    <div
                                        style="max-width: 200px;"
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <input type="number"
                                               class="form-control border-0 py-0 shadow-none form-input"
                                               placeholder=""
                                               autocomplete="off"
                                               v-model="item.qty"
                                               @change="onFeeQtyChange"
                                        >
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div>
                            <button type="button" class="btn btn-success" @click="save">Save fees</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalFees" class="modal-backdrop fade show"></div>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import moment from "moment/moment";
import Pagination from "./reusable/Pagination.vue";
import modalMixin from "../mixins/modalMixin";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";

export default {
    name: "DriverFees",
    components: {Pagination, DatePicker, Loading},
    mixins: [datePickerOptionsMixin, modalMixin, dataTablePaginationMixin],
    props: {
        url: {type: String, required: true}
    },
    watch: {
        filters: {
            handler: function(newValue) {
                if (this.$refs.pagination) {
                    this.$refs.pagination.changePage('', 1);
                }
            },
            deep: true
        }
    },
    data() {
        return {
            isLoading: false,
            tableUrl: this.url,
            perPage: [25, 10, 50, 100],
            orderBy: 'driver',
            orderDir: 'desc',
            activeModalFees: false,
            show: false,
            activeDriver: null,
            columns: [
                {
                    label: 'Date',
                    id: 'date',
                    orderable: false,
                },
                {
                    label: 'Driver',
                    id: 'driver',
                    orderable: true,
                },
                {
                    label: 'Cost',
                    id: 'cost',
                    orderable: true
                },
                {
                    label: 'Fees',
                    id: 'fees',
                    orderable: false,
                },
                {
                    label: 'Net cost',
                    id: 'net_cost',
                    orderable: false,
                },
                {
                    label: 'Validated',
                    id: 'validated',
                    orderable: true,
                }
            ],
            filters: {
                date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                length: 25,
                column: 'id',
                dir: 'desc',
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,

                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
            },
        }
    },
    methods: {
        onSelectDate() {
            console.log(this.filters.date);
        },
        sort(key) {
            if (key) {
                this.columns.forEach((column) => {
                    if (column.id === key && column.orderable) {
                        this.filters.column = key;
                        this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
                    }
                });
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        showFees(driverFee) {
            this.activeDriver = driverFee;
            this.modalToggle('activeModalFees');
        },
        onFeeQtyChange() {
            let total = 0;
            this.activeDriver.fees.fees.forEach((item, i) => {
                if (item.qty < 0) {
                    this.$set(this.activeDriver.fees.fees[i], 'qty', 0);
                }
                total += item.qty * item.price;
            });
            this.$set(this.activeDriver.fees, 'total', total);
        },
        save() {
            this.isLoading = false;
            axios.patch(`/driverfees/${this.activeDriver.id}/save`, {data: this.activeDriver})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.modalToggle('activeModalFees');
                }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            }).finally(() => {
                this.isLoading = false;
            })
        },
        saveAll() {
            this.isLoading = false;
            axios.post(`/driverfees/saveAll`, {data: this.$refs.table.tableData.data})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            }).finally(() => {
                this.isLoading = false;
            })
        },
        disabledDates(date) {
            date = moment(date);
            let now = moment();
            return date.isSameOrAfter(now);
        },
    },
    mounted() {
    },
    created() {
    },
}
</script>
<style scoped>
.modal-dialog {
    max-width: 1000px;
}

</style>
